
import { ref } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import TextBlock from '@/components/block/TextBlock.vue'

export default {
  name: 'ScoringCriteriaModal',

  components: {
    ModalBase,
    HeadingLv3,
    TextBlock
  },

  setup() {
    const contentHeight = ref(0)

    const getContentHeight = () => {
      const h = window.innerHeight
      if (window.innerWidth >= 900) {
        // ページ高さ - モーダルマージン(上) - モーダルマージン(下) - モーダルパディング(上下) - タイトル高さ
        return h - 95 - 80 - 80 - 54
      } else {
        // ページ高さ - モーダルマージン(上) - モーダルマージン(下) - タイトル高さ
        return h - 40 - 40 - 48
      }
    }
    contentHeight.value = getContentHeight()

    window.addEventListener('resize', () => {
      // スマホのツールバーの表示非表示でページ高さがすぐに反映されないときのための対策
      setTimeout(() => {
        contentHeight.value = getContentHeight()
      }, 200)
    })

    return {
      contentHeight
    }
  }
}
